import React, {Component} from 'react';
import CategoriesComponent from './CaregoriesComponent';
import {ApiBaseUrl} from '../../constants';
import AOS from 'aos';
import { withSnackbar } from 'react-simple-snackbar';
import {trackPromise} from "react-promise-tracker";

class HomeComponent extends Component {
    state = {
        categories:[]
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/home_categories_groups")
            .then(res => res.json())
            .then(
                (result) => {
                    result.data.push({'_id':'view_all', 'name':'View All','image':`${process.env.PUBLIC_URL}/image/view_all.png`,'categories':[]});
                    this.setState({
                        categories: result.data
                    });

                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
        AOS.init();
    }

    clickHandler = (event,index) => {
        event.preventDefault()
        if(this.state.categories[index].categories.length > 1)
            this.props.history.push({ pathname: process.env.PUBLIC_URL+'/vendors', state: { categories:this.state.categories[index].categories, title: this.state.categories[index].name}})
        else if(this.state.categories[index].categories.length === 1){
            if(this.state.categories[index].categories[0].alldayExists && this.state.categories[index].categories[0].onedayExists)
                this.props.history.push(process.env.PUBLIC_URL+'/select-category/'+this.state.categories[index].categories[0]._id)
            else if(this.state.categories[index].categories[0].alldayExists)
                this.props.history.push(process.env.PUBLIC_URL+'/category/allday/view-all/'+this.state.categories[index].categories[0]._id)
            else if(this.state.categories[index].categories[0].onedayExists)
                this.props.history.push(process.env.PUBLIC_URL+'/category/oneday/view-all/'+this.state.categories[index].categories[0]._id)
            else
                this.props.history.push(process.env.PUBLIC_URL+'/category/allday/view-all/')
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="home-section-desktop">
                    <div className="hero--image" style={{backgroundImage: "url('"+process.env.PUBLIC_URL+"/image/herbanner-bg.png')"}}></div>
                    <div className="silverbackhome-text">
                        <h1 className="entry--text">Welcome to <span>Vegas!</span></h1>
                        <h6>What experience are you looking for?</h6>
                    </div>
                </div>

                <div className="home-section-mobile">
                    <img className="img-fluid" src={`${process.env.PUBLIC_URL}/image/bannerImage.png`} alt=""/>
                </div>

                <div id="silverbackdeals" className="choose-deals-outer p-l-0 p-r-0">
                    <div className="container">
                        <div className="homepage-categories">
                            <h4 className="d--xs-none">pick your category</h4>
                        </div>
                        <div className="listing-categories">
                            <div className="row">
                                <CategoriesComponent clickHandler={this.clickHandler} categories={this.state.categories}/>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withSnackbar(HomeComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});